import { ResetPassword } from '../../models/resetPassword.model';
import { ForgotPassword } from '../../models/forgotPassword.model';
import { Login } from '../../models/login.model';
import { Token } from '../../models/token.model';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import { HttpClientBaseService } from '../base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { SessionHelper } from '../../helper/sessionHelper';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';
import { AppConfig } from '../../configuration/app.config';
import { User } from '../../models/user.model';
import { UserA3LRelations } from '../../models/userA3LRelations';


@Injectable()
export class AuthService extends HttpClientBaseService {

  constructor(
    private _session: SessionHelper,
    private _httpClient: HttpClient,
    private _ngxPermissionsService: NgxPermissionsService
  ) {
    super(_httpClient,'account/');
  }

  login(login: Login): Observable<Object> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    const url = this.getConcatUrl() + 'login';

    return this.http.post(url, login, { headers });
  }

  forgotPassword(forgotPasswordModel: ForgotPassword): Observable<Object> {
    const url = `${this.getConcatUrl()}ForgotPassword`;
    return this.http.post(url, forgotPasswordModel, { responseType: 'text' });
  }

  resetPassword(resetPasswordModel: ResetPassword): Observable<Object> {
    const url = `${this.getConcatUrl()}ResetPassword`;
    return this.http.post(url, resetPasswordModel, { responseType: 'text' });
  }

  refreshToken(refreshToken: string): Observable<any> {

    const headers = new HttpHeaders();

    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const body = `refresh_token=${refreshToken}&grant_type=refresh_token`;

    return this.http.post(AppConfig.settings.apiServer.tokenUrl, body, {headers});

  }

  correctLogin(token: any): boolean {
    try {


      const _token = token as Token;

      const user : User =  {
        Name: token.name,
        Surname: token.surname,
        Email: '',
        UserName: token.userName,
        Roles: token.roles.split(','),
        IdCliente: token.idCliente,
        // A3LCompanies: JSON.parse(token.companies) as UserA3LRelations[],
        isNew: false
      };

      this._session.SetSession(_token.access_token, _token.refresh_token, "", user);

      this._session.AccessTokenExpireIn = _token['.expires'];



      // Save permissions to localStorage.
      // sessionStorage.setItem(
      //   'permissions',
      //   JSON.stringify(token.roles.split(','))
      // );

      this._ngxPermissionsService.loadPermissions(token.roles.split(','));
      return true;
    } catch (error) {
      return false;
    }
  }

  logout() {
    this._session.Delete();
  }

  isLoggedIn() {
    if (this._session.AccessToken != null) {
      const expiredDate: Date = this._session.AccessTokenExpireIn;
      return (expiredDate.valueOf() > new Date().valueOf());
    } else {
      return false;
    }
  }
}
